var GenIcon = require('../lib').GenIcon

module.exports = function (props) {
   return GenIcon({"tag":"svg","attr":{"t":"1551322312294","className":"icon","style":{},"viewBox":"0 0 1024 1024","version":"1.1","fill":"currentColor"},"child":[{"tag":"defs","attr":{},"child":[{"tag":"style","attr":{"type":"text/css"}}]},{"tag":"path","attr":{"d":"M474 152m8 0l60 0q8 0 8 8l0 704q0 8-8 8l-60 0q-8 0-8-8l0-704q0-8 8-8Z"}},{"tag":"path","attr":{"d":"M168 474m8 0l672 0q8 0 8 8l0 60q0 8-8 8l-672 0q-8 0-8-8l0-60q0-8 8-8Z"}}]})(props);
};
